var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"Topbar navbar top-navbar navbar-expand-md"},_vm._l((_vm.items),function(item,index){return _c('ja-topbar-item',{key:index,attrs:{"classIcon":item.classIcon,"name":item.name,"slug":item.slug,"to":item.to}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }